import { createLucideIcon } from "lucide-react";

export const Email = createLucideIcon(
    "Email",
    [
        [
            "path",
            {
                d: "M1.33203 4L5.94071 6.61131C7.63976 7.57401 8.35763 7.57401 10.0567 6.61131L14.6654 4",
                key: "h71it9",
            },
        ],
        [
            "path",
            {
                d: "M1.34254 8.98367C1.38613 11.0274 1.40792 12.0492 2.162 12.8062C2.91609 13.5631 3.96559 13.5895 6.06458 13.6422C7.35824 13.6747 8.63916 13.6747 9.93282 13.6422C12.0318 13.5895 13.0813 13.5631 13.8354 12.8062C14.5895 12.0492 14.6113 11.0274 14.6549 8.98367C14.6689 8.32655 14.6689 7.6733 14.6549 7.01618C14.6113 4.97249 14.5895 3.95065 13.8354 3.19369C13.0813 2.43674 12.0318 2.41037 9.93282 2.35763C8.63916 2.32513 7.35824 2.32513 6.06458 2.35763C3.96558 2.41036 2.91609 2.43673 2.162 3.19368C1.40791 3.95064 1.38612 4.97248 1.34254 7.01617C1.32853 7.6733 1.32853 8.32654 1.34254 8.98367Z",
                key: "mj72uh",
            },
        ],
    ],
);
